/* Strand — theme.js
   Plain JavaScript, no libraries. Every feature binds through data-* hooks and
   re-initialises when a section is edited in the theme editor. */
(function () {
  'use strict';
  var d = document, root = d.documentElement, B = window.BHH || {}, KEY = 'bhh-theme';
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || d).querySelectorAll(s)); };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  if (designMode) d.body.classList.add('shopify-design-mode');

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = B.moneyFormat || '${{amount}}';
    cents = Number(cents) || 0;
    function f(n, dec, th, ds) { dec = dec == null ? 2 : dec; th = th || ','; ds = ds || '.';
      var p = (n / 100).toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(ds); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return f(cents, 0);
        case 'amount_with_comma_separator': return f(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return f(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return f(cents, 2, "'", '.');
        default: return f(cents, 2);
      }
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- theme toggle ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-theme-toggle]'); if (!b) return;
    var cur = root.getAttribute('data-theme') || (matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    var nx = cur === 'dark' ? 'light' : 'dark'; root.setAttribute('data-theme', nx);
    try { localStorage.setItem(KEY, nx); } catch (er) {}
  });

  /* ---------- header: hide on scroll ---------- */
  var last = 0;
  addEventListener('scroll', function () {
    var hw = $('#hwrap'); if (!hw || hw.dataset.hideOnScroll === 'false') return;
    var y = scrollY; hw.classList.toggle('hide', y > last && y > 300 && !$('.sheet.open')); last = y;
  }, { passive: true });

  /* ---------- header: mega sheets ---------- */
  var closeT;
  function closeSheets() { $$('.sheet').forEach(function (s) { s.classList.remove('open'); }); $$('[data-sheet]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
  function initHeader(scope) {
    var hw = $('#hwrap', scope) || (scope.id === 'hwrap' ? scope : null) || $('#hwrap'); if (!hw || hw.dataset.bound) return; hw.dataset.bound = '1';
    $$('[data-sheet]', hw).forEach(function (b) {
      var sh = d.getElementById('sheet-' + b.dataset.sheet); if (!sh) return;
      var open = function () { clearTimeout(closeT); if (!sh.classList.contains('open')) { closeSheets(); sh.classList.add('open'); b.setAttribute('aria-expanded', 'true'); } };
      b.addEventListener('mouseenter', function () { if (matchMedia('(hover:hover)').matches) open(); });
      sh.addEventListener('mouseenter', function () { clearTimeout(closeT); });
      b.addEventListener('click', function () { var o = sh.classList.contains('open'); closeSheets(); if (!o) { sh.classList.add('open'); b.setAttribute('aria-expanded', 'true'); } });
    });
    hw.addEventListener('mouseleave', function () { clearTimeout(closeT); closeT = setTimeout(closeSheets, 280); });
    hw.addEventListener('mouseenter', function () { clearTimeout(closeT); });
    $$('.hnav > a', hw).forEach(function (a) { a.addEventListener('mouseenter', closeSheets); });
  }
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSheets(); closeAll(); } });

  /* ---------- overlays: mobile nav, cart drawer, search, filters ---------- */
  function openPanel(el) {
    if (!el) return; closeAll(); el.classList.add('open');
    var ov = $('#overlay'); if (ov && !el.classList.contains('mnav')) ov.classList.add('open');
    d.body.style.overflow = 'hidden';
    var f = el.querySelector('input[type="search"],input[name="q"],button,a'); if (f) setTimeout(function () { f.focus(); }, 320);
  }
  function closeAll() {
    $$('.mnav.open,.drawer.open,.searchbox.open,.filters.open').forEach(function (x) { x.classList.remove('open'); });
    var ov = $('#overlay'); if (ov) ov.classList.remove('open'); d.body.style.overflow = '';
  }
  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { var t = d.getElementById(o.dataset.open); if (t) { e.preventDefault(); openPanel(t); if (o.dataset.open === 'cart') refreshCart(); } return; }
    if (e.target.closest('[data-close]') || e.target.id === 'overlay') { closeAll(); return; }
    if (e.target.closest('.mnav a')) closeAll();
  });

  /* ---------- reveal on scroll ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.1 }) : null;
  function initReveal(scope) {
    var els = $$('.reveal', scope);
    if (!io || designMode || d.body.classList.contains('no-reveal')) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    els.forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 70 + 'ms'; io.observe(el); });
  }

  /* ---------- shade bar ---------- */
  d.addEventListener('click', function (e) {
    var s = e.target.closest('.shade'); if (!s || e.target.closest('a')) return;
    var o = s.classList.contains('open'); $$('.shade.open').forEach(function (x) { x.classList.remove('open'); }); if (!o) s.classList.add('open');
  });
  d.addEventListener('keydown', function (e) { var s = e.target.closest && e.target.closest('.shade'); if (s && e.key === 'Enter' && e.target === s) s.click(); });

  /* ---------- tabs ---------- */
  function initTabs(scope) {
    $$('[data-tabs]', scope).forEach(function (wrap) {
      var tabs = $$('[role="tab"]', wrap), ink = $('.ink', wrap);
      function move(t) { if (ink && t) { ink.style.left = t.offsetLeft + 'px'; ink.style.width = t.offsetWidth + 'px'; } }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.setAttribute('aria-selected', 'false'); x.tabIndex = -1; var p = d.getElementById(x.getAttribute('aria-controls')); if (p) p.classList.remove('on'); });
          t.setAttribute('aria-selected', 'true'); t.tabIndex = 0; var p = d.getElementById(t.getAttribute('aria-controls')); if (p) p.classList.add('on'); move(t);
        });
        t.addEventListener('keydown', function (e) { var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (k) { var n = tabs[(i + k + tabs.length) % tabs.length]; n.focus(); n.click(); } });
      });
      var init = function () { move($('[aria-selected="true"]', wrap)); };
      init(); addEventListener('resize', init); if (d.fonts) d.fonts.ready.then(init);
    });
  }

  /* ---------- before / after ---------- */
  d.addEventListener('input', function (e) {
    var r = e.target; if (!r.matches('.compare input[type="range"]')) return;
    var c = r.closest('.compare'); $('.after', c).style.clipPath = 'inset(0 0 0 ' + r.value + '%)'; $('.bar', c).style.left = r.value + '%';
  });

  /* ---------- chip filters (lookbook) ---------- */
  d.addEventListener('click', function (e) {
    var c = e.target.closest('[data-chipfilter] .chip'); if (!c) return;
    var bar = c.closest('[data-chipfilter]'), target = d.getElementById(bar.dataset.chipfilter);
    $$('.chip', bar).forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); }); c.classList.add('on'); c.setAttribute('aria-pressed', 'true');
    $$('[data-tags]', target).forEach(function (it) {
      var tags = (it.dataset.tags || '').toLowerCase().split(','), f = (c.dataset.f || 'all').toLowerCase();
      var ok = f === 'all' || tags.map(function (t) { return t.trim(); }).indexOf(f) > -1; it.style.display = ok ? '' : 'none';
    });
  });

  /* ---------- service finder ---------- */
  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-finder] .fopt'); if (!o) return;
    var f = o.closest('[data-finder]');
    $$('.fopt', f).forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); }); o.classList.add('on'); o.setAttribute('aria-pressed', 'true');
    $$('.fresult', f).forEach(function (x) { x.classList.remove('on'); }); var r = d.getElementById(o.dataset.r); if (r) r.classList.add('on');
  });

  /* ---------- process steps light up ---------- */
  function processTick() {
    $$('.process').forEach(function (p) {
      var st = $$('.pstep', p), r = p.getBoundingClientRect(), k = (innerHeight * 0.8 - r.top) / (r.height + innerHeight * 0.3);
      k = Math.max(0, Math.min(1, k)); var n = Math.round(k * st.length); st.forEach(function (s, i) { s.classList.toggle('on', i < n); });
    });
  }
  addEventListener('scroll', processTick, { passive: true });

  /* ---------- toast ---------- */
  var tt;
  function toast(html) { var t = $('#toast'); if (!t) return; t.innerHTML = html; t.classList.add('show'); clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('show'); }, 3200); }

  /* ---------- cart (Shopify AJAX API) ---------- */
  var R = B.routes || { root: '/', cart: '/cart' };
  function api(path, body) {
    return fetch(R.root.replace(/\/$/, '') + path, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function setCount(n) { $$('[data-cart-count]').forEach(function (e) { e.textContent = n; e.setAttribute('data-n', n); }); }
  function renderCart(c) {
    setCount(c.item_count);
    var S = B.strings || {};
    $$('[data-cart-lines]').forEach(function (box) {
      if (!c.items.length) {
        box.innerHTML = '<div class="empty"><b>' + esc(S.empty) + '</b>' + esc(S.emptyText) + '<br><br><a class="pill pill-a pill-sm" href="' + esc(B.collectionsAll || '/collections/all') + '">' + esc(S.emptyBtn) + '</a></div>';
        return;
      }
      box.innerHTML = c.items.map(function (x) {
        var img = x.image ? x.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (x.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
        var opts = (x.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.value); }).join(' · ');
        var props = x.properties ? Object.keys(x.properties).filter(function (k) { return k.charAt(0) !== '_' && x.properties[k]; }).map(function (k) { return esc(k) + ': ' + esc(x.properties[k]); }).join('<br>') : '';
        return '<div class="line-item" data-key="' + esc(x.key) + '"><a class="photo" href="' + esc(x.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a><div><h4><a href="' + esc(x.url) + '">' + esc(x.product_title) + '</a></h4>' +
          (opts ? '<small>' + opts + '</small>' : '') + (props ? '<small>' + props + '</small>' : '') +
          '<div class="qty"><button type="button" data-line-q="-1" aria-label="Decrease">−</button><input value="' + x.quantity + '" aria-label="Quantity" inputmode="numeric" data-line-input><button type="button" data-line-q="1" aria-label="Increase">+</button></div>' +
          '<button type="button" class="rm" data-line-rm>' + esc(S.remove || 'Remove') + '</button></div><div class="lp">' + money(x.final_line_price) + (x.original_line_price > x.final_line_price ? '<s>' + money(x.original_line_price) + '</s>' : '') + '</div></div>';
      }).join('');
    });
    $$('[data-cart-sub]').forEach(function (e) { e.textContent = money(c.total_price); });
    $$('[data-cart-has]').forEach(function (e) { e.style.display = c.item_count ? '' : 'none'; });
    var free = B.freeShip || 0;
    $$('[data-ship-bar]').forEach(function (e) {
      if (!free) { e.style.display = 'none'; return; }
      var left = Math.max(0, free - c.total_price), msg = $('.msg', e), bar = $('i', e);
      msg.innerHTML = left > 0 ? esc(S.shipLeft || '').replace('[amount]', '<b>' + money(left) + '</b>') : esc(S.shipDone || '');
      bar.style.width = Math.min(100, c.total_price / free * 100) + '%';
    });
  }
  function refreshCart() { return api('/cart.js').then(renderCart).catch(function () {}); }
  function changeLine(key, qty, el) {
    if (el) el.classList.add('loading');
    return api('/cart/change.js', { id: key, quantity: qty }).then(function (c) { renderCart(c); if (/\/cart\/?$/.test(location.pathname)) location.reload(); })
      .catch(function (err) { if (el) el.classList.remove('loading'); toast(esc((err && (err.description || err.message)) || 'Could not update cart')); });
  }
  d.addEventListener('click', function (e) {
    var line = e.target.closest('[data-key]'); if (!line || !line.closest('[data-cart-lines]')) return;
    var input = $('[data-line-input]', line), q = +input.value || 1;
    if (e.target.closest('[data-line-q]')) changeLine(line.dataset.key, Math.max(0, q + (+e.target.closest('[data-line-q]').dataset.lineQ)), line);
    if (e.target.closest('[data-line-rm]')) changeLine(line.dataset.key, 0, line);
  });
  d.addEventListener('change', function (e) {
    if (!e.target.matches('[data-line-input]')) return;
    var line = e.target.closest('[data-key]'); changeLine(line.dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0), line);
  });
  function addToCart(items, btn) {
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    return api('/cart/add.js', { items: items }).then(function () {
      return refreshCart().then(function () {
        var S = B.strings || {};
        toast(esc(S.added || 'Added to cart') + ' — <a href="' + esc(R.cart) + '" data-open="cart">' + esc(S.viewCart || 'View cart') + '</a>');
        var dr = $('#cart'); if (dr && dr.dataset.autoOpen === 'true') openPanel(dr);
      });
    }).catch(function (err) { toast(esc((err && (err.description || err.message)) || 'Could not add to cart')); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }
  d.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]'); if (!q) return; e.preventDefault(); e.stopPropagation();
    addToCart([{ id: +q.dataset.quickAdd, quantity: 1 }], q);
  });

  /* ---------- product page ---------- */
  function initProduct(scope) {
    $$('[data-pdp]', scope).forEach(function (pdp) {
      if (pdp.dataset.bound) return; pdp.dataset.bound = '1';
      var json = $('[data-variants]', pdp), variants = json ? JSON.parse(json.textContent) : [];
      var form = $('form[data-product-form]', pdp), idIn = form ? $('input[name="id"]', form) : null;
      var priceEl = $('[data-price]', pdp), cmpEl = $('[data-compare]', pdp), btn = $('[data-add]', pdp), stock = $('[data-stock]', pdp), qIn = $('[data-qty]', pdp);
      var S = B.strings || {};
      /* gallery */
      var main = $('[data-gmain]', pdp);
      function showMedia(id) {
        var t = $('[data-thumb="' + id + '"]', pdp); if (!t) return;
        $$('[data-thumb]', pdp).forEach(function (x) { x.setAttribute('aria-current', 'false'); }); t.setAttribute('aria-current', 'true');
        $$('[data-slide]', pdp).forEach(function (s) { s.hidden = s.dataset.slide !== String(id); });
      }
      $$('[data-thumb]', pdp).forEach(function (b) { b.addEventListener('click', function () { showMedia(b.dataset.thumb); }); });
      var zoom = $('[data-zoom]', pdp), dlg = $('[data-zoom-dialog]', pdp);
      if (zoom && dlg && dlg.showModal) zoom.addEventListener('click', function () {
        var vis = $$('[data-slide]', pdp).filter(function (s) { return !s.hidden; })[0], img = vis && $('img', vis);
        if (!img) return; $('img', dlg).src = img.currentSrc || img.src; dlg.showModal();
      });
      /* options */
      function selected() { return $$('[data-option-group]', pdp).map(function (g) { var c = $('input:checked', g) || $('select', g); return c ? c.value : null; }); }
      function current() { var s = selected(); return variants.filter(function (v) { return v.options.every(function (o, i) { return s[i] == null || o === s[i]; }); })[0]; }
      function sync(push) {
        var v = current(), qty = qIn ? Math.max(1, +qIn.value || 1) : 1;
        $$('[data-option-group]', pdp).forEach(function (g, gi) {
          var lab = $('[data-sel]', g); var c = $('input:checked', g); if (lab && c) lab.textContent = c.value;
          $$('input', g).forEach(function (inp) {
            var s = selected(); s[gi] = inp.value;
            var exists = variants.filter(function (vv) { return vv.options.every(function (o, i) { return s[i] == null || o === s[i]; }); });
            var avail = exists.some(function (vv) { return vv.available; });
            var lbl = inp.closest('label'); if (lbl) { lbl.classList.toggle('na', !avail); lbl.setAttribute('aria-pressed', inp.checked ? 'true' : 'false'); }
          });
        });
        if (!v) { if (btn) { btn.disabled = true; btn.textContent = S.unavailable || 'Unavailable'; } return; }
        if (idIn) idIn.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (cmpEl) { cmpEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
        if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? (btn.dataset.label || S.addToCart || 'Add to cart') + ' — ' + money(v.price * qty) : (S.soldOut || 'Sold out'); }
        if (stock) { stock.classList.toggle('out', !v.available); stock.textContent = v.available ? S.inStock : S.outStock; }
        $$('[data-sticky-price]').forEach(function (e) { e.textContent = money(v.price); });
        $$('[data-sticky-add]').forEach(function (b) { b.disabled = !v.available; });
        if (v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);
        if (push && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
      }
      $$('[data-option-group] input, [data-option-group] select', pdp).forEach(function (i) { i.addEventListener('change', function () { sync(true); }); });
      $$('[data-qty-step]', pdp).forEach(function (b) { b.addEventListener('click', function () { qIn.value = Math.max(1, (+qIn.value || 1) + (+b.dataset.qtyStep)); sync(); }); });
      if (qIn) qIn.addEventListener('change', function () { sync(); });
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault(); if (btn && btn.disabled) return;
        var fd = new FormData(form), props = {};
        fd.forEach(function (val, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && val) props[m[1]] = val; });
        var item = { id: +idIn.value, quantity: qIn ? Math.max(1, +qIn.value || 1) : 1 }; if (Object.keys(props).length) item.properties = props;
        addToCart([item], btn);
      });
      $$('[data-sticky-add]').forEach(function (b) { b.addEventListener('click', function () { if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); }); });
      var sb = $('.sticky-buy'); if (sb && btn && 'IntersectionObserver' in window) new IntersectionObserver(function (es) { sb.classList.toggle('show', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(btn);
      sync(false);
    });
  }

  /* ---------- collection filters: submit on change ---------- */
  var ft;
  d.addEventListener('change', function (e) {
    var f = e.target.closest('form[data-filter-form]');
    if (f) { clearTimeout(ft); ft = setTimeout(function () { submitFilters(f); }, e.target.type === 'number' ? 700 : 50); return; }
    if (e.target.matches('[data-sort]')) { var u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location.href = u.toString(); }
  });
  function submitFilters(f) {
    var params = new URLSearchParams(new FormData(f)); var del = [];
    params.forEach(function (v, k) { if (v === '') del.push(k); }); del.forEach(function (k) { params.delete(k); });
    var sort = new URLSearchParams(location.search).get('sort_by'); if (sort) params.set('sort_by', sort);
    location.href = location.pathname + (params.toString() ? '?' + params.toString() : '');
  }

  /* ---------- predictive search ---------- */
  var pt;
  d.addEventListener('input', function (e) {
    var inp = e.target; if (!inp.matches('[data-predictive]')) return;
    var box = $('[data-ps-results]', inp.closest('.searchbox') || d); if (!box) return;
    clearTimeout(pt); var q = inp.value.trim();
    if (q.length < 2) { box.innerHTML = ''; return; }
    pt = setTimeout(function () {
      var url = R.root.replace(/\/$/, '') + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page,article,collection&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url).then(function (r) { return r.json(); }).then(function (j) {
        var res = (j.resources && j.resources.results) || {}, html = '';
        function list(title, arr, map) { if (!arr || !arr.length) return ''; return '<div><h6>' + esc(title) + '</h6><div class="ps-list">' + arr.map(map).join('') + '</div></div>'; }
        html += list('Products', res.products, function (p) { return '<a class="ps-item" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '&width=120" alt="" loading="lazy">' : '<span class="ps-ph"></span>') + '<span><b>' + esc(p.title) + '</b><small>' + esc(p.type || '') + '</small></span><span>' + (p.price ? money(Math.round(parseFloat(p.price) * 100)) : '') + '</span></a>'; });
        html += list('Pages', res.pages, function (p) { return '<a class="ps-item" href="' + esc(p.url) + '"><span class="ps-ph"></span><span><b>' + esc(p.title) + '</b></span><span></span></a>'; });
        html += list('Journal', res.articles, function (p) { return '<a class="ps-item" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '&width=120" alt="" loading="lazy">' : '<span class="ps-ph"></span>') + '<span><b>' + esc(p.title) + '</b></span><span></span></a>'; });
        html += list('Collections', res.collections, function (p) { return '<a class="ps-item" href="' + esc(p.url) + '"><span class="ps-ph"></span><span><b>' + esc(p.title) + '</b></span><span></span></a>'; });
        box.innerHTML = html ? html + '<a class="ps-all" href="' + esc(R.search) + '?q=' + encodeURIComponent(q) + '&options[prefix]=last">See all results for “' + esc(q) + '” →</a>' : '<div class="empty">' + esc((B.strings || {}).noResults || 'No results') + '</div>';
      }).catch(function () {});
    }, 220);
  });

  /* ---------- form validation (only blocks submit when invalid) ---------- */
  function validate(scope) {
    var ok = true;
    $$('[required]', scope).forEach(function (f) {
      if (f.disabled || f.closest('[hidden]')) return;
      var fld = f.closest('.field'), bad = f.type === 'email' ? !/^\S+@\S+\.\S+$/.test(f.value) : !String(f.value).trim();
      if (f.type === 'radio') bad = !$('input[name="' + CSS.escape(f.name) + '"]:checked', scope);
      if (f.type === 'checkbox') bad = !f.checked;
      if (fld) fld.classList.toggle('err', bad); if (bad) ok = false;
    });
    if (!ok) { var e = $('.err', scope); if (e) e.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    return ok;
  }
  d.addEventListener('submit', function (e) { var f = e.target; if (f.matches('[data-validate]') && !validate(f)) e.preventDefault(); }, true);

  /* ---------- booking intake ---------- */
  function initBooking(scope) {
    $$('[data-book]', scope).forEach(function (bk) {
      if (bk.dataset.bound) return; bk.dataset.bound = '1';
      var steps = $$('.bstep', bk), dots = $$('.stepper span', bk), cur = 0;
      function go(n) {
        cur = n; steps.forEach(function (s, i) { s.classList.toggle('on', i === n); });
        dots.forEach(function (s, i) { s.classList.toggle('on', i === n); s.classList.toggle('done', i < n); });
        var top = bk.getBoundingClientRect().top + scrollY - 110; scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' }); summary();
      }
      function chosen() { return $('input[name="contact[Service]"]:checked', bk); }
      function summary() {
        var s = chosen(), nm = $('[name="contact[name]"]', bk), goal = $('input[name="contact[Main goal]"]:checked', bk);
        var set = function (k, v) { $$('[data-sum-' + k + ']', bk).forEach(function (e) { e.textContent = v || '—'; }); };
        set('service', s && s.value); set('price', s && s.dataset.price); set('name', nm && nm.value); set('goal', goal && goal.value);
      }
      var params = new URLSearchParams(location.search), pre = params.get('service');
      if (pre) { var r0 = $('input[name="contact[Service]"][data-key="' + CSS.escape(pre) + '"]', bk); if (r0) r0.checked = true; }
      $$('[data-next]', bk).forEach(function (b) { b.addEventListener('click', function () { if (validate(steps[cur])) go(cur + 1); }); });
      $$('[data-prev]', bk).forEach(function (b) { b.addEventListener('click', function () { go(Math.max(0, cur - 1)); }); });
      bk.addEventListener('change', summary);
      bk.addEventListener('input', summary);
      var form = $('form', bk);
      if (form) form.addEventListener('submit', function (e) {
        if (!validate(steps[cur])) { e.preventDefault(); return; }
        var s = chosen(); try { sessionStorage.setItem('bhh-book', JSON.stringify({ url: s ? s.dataset.square : '', label: s ? s.value : '' })); } catch (er) {}
      });
      var posted = $('[data-book-posted]', bk);
      if (posted) {
        var saved = {}; try { saved = JSON.parse(sessionStorage.getItem('bhh-book') || '{}'); } catch (er) {}
        var link = $('[data-square-link]', bk); if (link && saved.url) link.href = saved.url;
        $$('[data-sum-service]', bk).forEach(function (e) { if (saved.label) e.textContent = saved.label; });
        go(steps.length - 1);
      }
      $$('.upload input', bk).forEach(function (i) { i.addEventListener('change', function () { var l = i.closest('.upload'); $('b', l).textContent = i.files.length ? i.files.length + ' photo(s) selected' : l.dataset.label; }); });
      summary();
    });
  }

  /* ---------- article table of contents ---------- */
  function initToc(scope) {
    $$('[data-toc]', scope).forEach(function (toc) {
      var body = d.querySelector(toc.dataset.toc); if (!body) return;
      var heads = $$('h2', body); if (!heads.length) { toc.hidden = true; return; }
      var list = $('[data-toc-list]', toc) || toc;
      list.innerHTML = heads.map(function (h, i) { if (!h.id) h.id = 'section-' + (i + 1); return '<a href="#' + h.id + '">' + esc(h.textContent) + '</a>'; }).join('');
      var links = $$('a', list);
      addEventListener('scroll', function () { var i = heads.length - 1; while (i > 0 && heads[i].getBoundingClientRect().top > 160) i--; links.forEach(function (a, j) { a.classList.toggle('on', j === i); }); }, { passive: true });
    });
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]'); if (!b) return;
    try { navigator.clipboard.writeText(location.href); toast(esc((B.strings || {}).linkCopied || 'Link copied')); } catch (er) {}
  });

  /* ---------- 3D cascading footer ---------- */
  function cascade() {
    var tiers = $$('.cascade:not(.no-3d) .tier'); if (!tiers.length) return;
    var vh = innerHeight, maxA = innerWidth < 760 ? -38 : -78;
    tiers.forEach(function (t) {
      var top = t.getBoundingClientRect().top, h = t.offsetHeight, p = (vh - top) / Math.min(vh * 0.5, h * 0.85); p = Math.max(0, Math.min(1, p));
      var e = 1 - Math.pow(1 - p, 3); t.style.transform = 'perspective(1400px) rotateX(' + (maxA * (1 - e)).toFixed(2) + 'deg)'; t.style.opacity = (0.2 + 0.8 * e).toFixed(3);
    });
  }
  if (!reduce) { addEventListener('scroll', function () { requestAnimationFrame(cascade); }, { passive: true }); addEventListener('resize', cascade); }

  /* ---------- service menu: photo arch follows the cursor (hover screens > 1100px) ---------- */
  var floatArch = null;
  function initFloatArch(scope) {
    if (!matchMedia('(hover:hover) and (min-width:1101px)').matches) return;
    var rows = $$('.svx[data-float] .svx-row[data-img]', scope); if (!rows.length) return;
    if (!floatArch) { floatArch = d.createElement('div'); floatArch.className = 'float-arch'; floatArch.setAttribute('aria-hidden', 'true'); floatArch.innerHTML = '<img alt="">'; d.body.appendChild(floatArch); }
    var fa = floatArch, fimg = fa.firstChild;
    rows.forEach(function (r) {
      if (r.dataset.faBound) return; r.dataset.faBound = 1;
      r.addEventListener('mouseenter', function () { fimg.src = r.dataset.img; fa.classList.add('on'); });
      r.addEventListener('mouseleave', function () { fa.classList.remove('on'); });
      r.addEventListener('mousemove', function (e) { fa.style.left = e.clientX + 'px'; fa.style.top = e.clientY + 'px'; });
    });
  }

  /* ---------- init + theme editor support ---------- */
  function init(scope) {
    scope = scope || d;
    initHeader(scope); initReveal(scope); initTabs(scope); initProduct(scope); initBooking(scope); initToc(scope); initFloatArch(scope);
    processTick(); if (!reduce) cascade();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); }); else init(d);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
  d.addEventListener('shopify:block:select', function (e) {
    var sh = e.target.closest('.sheet'); if (sh) { closeSheets(); sh.classList.add('open'); }
    var shade = e.target.closest('.shade'); if (shade) shade.classList.add('open');
    var panel = e.target.closest('[role="tabpanel"]'); if (panel) { var t = d.querySelector('[aria-controls="' + panel.id + '"]'); if (t) t.click(); }
    var tier = e.target.closest('.tier'); if (tier) { tier.style.transform = 'none'; tier.style.opacity = 1; }
  });
  d.addEventListener('shopify:block:deselect', function (e) { var sh = e.target.closest('.sheet'); if (sh) sh.classList.remove('open'); });
  d.addEventListener('shopify:section:select', function (e) { $$('.reveal', e.target).forEach(function (el) { el.classList.add('in'); }); });
  window.BHHTheme = { refreshCart: refreshCart, addToCart: addToCart, money: money, openPanel: openPanel };
})();
